import { c as _c } from "react/compiler-runtime";
import React, { Fragment } from 'react';
import { BaseTable, BaseTableProps } from './components/base-table';
import { ColumnDefinitionInterface } from './types/column-interface';
import { calculateTableTotalWidth } from './utils';
export interface ColumnWithExtraHeaderInterface<T> extends ColumnDefinitionInterface<T> {
  extraHeader: React.ReactNode;
}
interface TableWithExtraHeadersProps<T> extends Omit<BaseTableProps<T>, 'columns'> {
  columns: ColumnWithExtraHeaderInterface<T>[];
}
export function TableWithExtraHeaders(t0) {
  const $ = _c(22);
  let columns;
  let props;
  if ($[0] !== t0) {
    ({
      columns,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = columns;
    $[2] = props;
  } else {
    columns = $[1];
    props = $[2];
  }
  let t1;
  let tableColumns;
  if ($[3] !== columns) {
    tableColumns = columns.map(_temp);
    t1 = calculateTableTotalWidth(tableColumns);
    $[3] = columns;
    $[4] = t1;
    $[5] = tableColumns;
  } else {
    t1 = $[4];
    tableColumns = $[5];
  }
  const totalWidth = t1;
  const t2 = columns.length * 252;
  let t3;
  if ($[6] !== t2) {
    t3 = {
      minWidth: t2
    };
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== columns || $[9] !== totalWidth) {
    let t5;
    if ($[11] !== totalWidth) {
      t5 = (column, index) => {
        const widthPercent_0 = column.widthPercent || 25;
        return <Fragment key={`extraHeaderCell-${index}`}><div className="hidden truncate px-6 py-4 lg:table-cell" style={{
            flex: `${widthPercent_0 / totalWidth * 100}`
          }}>{column.extraHeader}</div><div className="w-full truncate lg:hidden lg:px-6 lg:py-2.5"><div className="flex items-center gap-3"><span className="text-text-primary whitespace-nowrap font-bold">{column.header}</span>{column.extraHeader}</div></div></Fragment>;
      };
      $[11] = totalWidth;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    t4 = columns.map(t5);
    $[8] = columns;
    $[9] = totalWidth;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[13] !== t4) {
    t5 = <div className={"bg-background-secondary main-transition-colors  \n          hover:border-brand-primary flex flex-col\n          items-start gap-4 rounded-t-lg border border-transparent px-6 py-4 \n          lg:flex-row lg:items-center lg:gap-0 lg:p-0\n          "}>{t4}</div>;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== props || $[16] !== tableColumns) {
    t6 = <BaseTable columns={tableColumns} {...props} />;
    $[15] = props;
    $[16] = tableColumns;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t3 || $[19] !== t5 || $[20] !== t6) {
    t7 = <div className="overflow-auto"><div style={t3}>{t5}{t6}</div></div>;
    $[18] = t3;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
}
function _temp(t0) {
  const {
    key,
    header,
    widthPercent,
    onRender,
    onRenderSmall,
    shouldRender
  } = t0;
  return {
    key,
    header,
    widthPercent,
    onRender,
    onRenderSmall,
    shouldRender
  };
}